var exports = {
  "PT": "Markup.module__markup___QkVFbj",
  "z3": "Markup.module__bio___QkVFbj",
  "Z_": "Markup.module__mutedSpoilerContext___QkVFbj",
  "nf": "Markup.module__link___QkVFbj",
  "mG": "Markup.module__inline___QkVFbj",
  "tZ": "Markup.module__inlineFormat___QkVFbj",
  "Hy": "Markup.module__codeContainer___QkVFbj",
  "h": "Markup.module__blockquoteContainer___QkVFbj",
  "xE": "Markup.module__alert___QkVFbj",
  "CZ": "Markup.module__tableContainer___QkVFbj",
  "js": "Markup.module__latexCodeBlock___QkVFbj",
  "lB": "Markup.module__codeActions___QkVFbj",
  "vo": "Markup.module__codeActionsVisible___QkVFbj",
  "r": "Markup.module__blockquoteDivider___QkVFbj",
  "rs": "Markup.module__blockquoteContent___QkVFbj",
  "em": "Markup.module__blockquoteEmptyContent___QkVFbj",
  "tp": "Markup.module__table___QkVFbj",
  "qd": "Markup.module__tableHeader___QkVFbj",
  "xR": "Markup.module__tableCell___QkVFbj",
  "Vl": "Markup.module__alignLeft___QkVFbj",
  "Hu": "Markup.module__alignCenter___QkVFbj",
  "Wk": "Markup.module__alignRight___QkVFbj",
  "Qd": "Markup.module__alertIcon___QkVFbj",
  "Ro": "Markup.module__alertTitle___QkVFbj",
  "S9": "Markup.module__alertContent___QkVFbj",
  "FU": "Markup.module__alertNote___QkVFbj",
  "ap": "Markup.module__alertTip___QkVFbj",
  "nL": "Markup.module__alertImportant___QkVFbj",
  "vc": "Markup.module__alertWarning___QkVFbj",
  "SN": "Markup.module__alertCaution___QkVFbj",
  "lE": "Markup.module__mention___QkVFbj",
  "bG": "Markup.module__interactive___QkVFbj",
  "vE": "Markup.module__timestamp___QkVFbj",
  "CU": "Markup.module__spoilerWrapper___QkVFbj",
  "N5": "Markup.module__blockSpoilerWrapper___QkVFbj",
  "p6": "Markup.module__spoiler___QkVFbj",
  "mC": "Markup.module__blockSpoiler___QkVFbj",
  "ur": "Markup.module__spoilerContent___QkVFbj",
  "yI": "Markup.module__latexContent___QkVFbj",
  "Y4": "Markup.module__hljs___QkVFbj",
  "HQ": "Markup.module__ansiCode___QkVFbj",
  "bi": "Markup.module__ansi-code-blink___QkVFbj",
  "So": "Markup.module__error___QkVFbj",
};

module.exports = exports;
